import { isValidNumber, parsePhoneNumber } from 'libphonenumber-js';

export const isValidNum = (numString: string) => {
  return isValidNumber(numString)
}

export const parsePhoneNum = (numString: string) => {
  try {
    const phoneNumber = parsePhoneNumber(numString)
    return phoneNumber
  } catch(e) {
    return ''
  }
}
